import { jsx as _jsx } from "react/jsx-runtime";
const ModalFooterButtons = ({ children }) => {
    return _jsx("div", Object.assign({ className: "modal-footer-buttons" }, { children: children }));
};
export default ModalFooterButtons;
